import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LayoutRoutes from './LayoutRoutes'
import PrivateRoutes from './PrivateRoutes';
import SignIn from '../Auth';
import RegisterWithBgImage from '../Components/Pages/Others/Authentication/RegisterWithBgImage';
import AcceptInvitePage from '../Components/Group/GroupList/Common/AcceptInvitePage';
import ChangeParticipantPasswordPage from '../Components/Group/GroupList/Common/ChangeParticipantPasswordPage';
import ForgotPasswordForm from '../Components/Auth/ForgotPasswordForm';

export default function Routers() {
    const login = localStorage.getItem("login");
    return (
        // <BrowserRouter basename={'/'}>
            <Routes>
                {login ? (
                    <>
                                            <Route path={"/"} element={<PrivateRoutes />}>

                        <Route path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                        <Route path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} />} />
                        </Route>
                    </>
                ) : (
                    ""
                )}
                {
                    /* 
                        // Private route reference
                        <Route path={"/"} element={<PrivateRoutes />}>
                            <Route path={`/*`} element={<LayoutRoutes />} />
                        </Route> 
                    */
                }
                <Route path={"/"}>
                    <Route path={`/*`} element={<LayoutRoutes />} />
                </Route>
                    <Route path={`/login`} element={<SignIn />} />
                <Route path={`/register`} element={<RegisterWithBgImage />} />
                <Route path={`/forgot-password`} element={<ForgotPasswordForm />} />

                <Route path={`/group/check-code`} element={<AcceptInvitePage />} />
                <Route path={`/group/set-password`} element={<ChangeParticipantPasswordPage />} />

            </Routes>
        // </BrowserRouter>
    )
}